module.exports = __webpack_public_path__ + "img/ivTest_sub52.e355532d.png";